import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { signOut } from "../utils/supabaseClient";
import { isBlogAdmin } from "./AdminRoute";
import useTeacherUnreadCounts from "../hooks/useTeacherUnreadCounts";

const links = [
  {
    name: "Home",
    path: "/",
    icon: (
      <svg
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"
        />
      </svg>
    ),
  },
  {
    name: "Students",
    path: "/students",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-people-fill" viewBox="0 0 16 16">
        <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
      </svg>
    ),
  },
  {
    name: "Schedule",
    path: "/schedule",
    icon: (
      <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    name: "Lessons",
    path: "/lessons",
    icon: (
      <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M11 4.717c-2.286-.58-4.16-.756-7.045-.71A1.99 1.99 0 0 0 2 6v11c0 1.133.934 2.022 2.044 2.007 2.759-.038 4.5.16 6.956.791V4.717Zm2 15.081c2.456-.631 4.198-.829 6.956-.791A2.013 2.013 0 0 0 22 16.999V6a1.99 1.99 0 0 0-1.955-1.993c-2.885-.046-4.76.13-7.045.71v15.081Z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    name: "Business",
    path: "/business",
    icon: (
      <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M10 2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v2.382l1.447.723.005.003.027.013.12.056c.108.05.272.123.486.212.429.177 1.056.416 1.834.655C7.481 13.524 9.63 14 12 14c2.372 0 4.52-.475 6.08-.956.78-.24 1.406-.478 1.835-.655a14.028 14.028 0 0 0 .606-.268l.027-.013.005-.002L22 11.381V9a3 3 0 0 0-3-3h-2V5a3 3 0 0 0-3-3h-4Zm5 4V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1h6Zm6.447 7.894.553-.276V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-5.382l.553.276.002.002.004.002.013.006.041.02.151.07c.13.06.318.144.557.242.478.198 1.163.46 2.01.72C7.019 15.476 9.37 16 12 16c2.628 0 4.98-.525 6.67-1.044a22.95 22.95 0 0 0 2.01-.72 15.994 15.994 0 0 0 .707-.312l.041-.02.013-.006.004-.002.001-.001-.431-.866.432.865ZM12 10a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    name: "Novas Community",
    path: "/community",
    icon: (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  {
    name: "Blog",
    path: "/blog/admin",
    adminOnly: true,
    icon: (
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4 5a2 2 0 0 1 2-2h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Z"
        />
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 3v5h5M8 12h8M8 16h5" />
      </svg>
    ),
  },
];

export default function Sidebar() {
  const [tooltip, setTooltip] = useState({ show: false, text: "", top: 0 });
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('currentUser') || '{}'));
  const sidebarRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const { total: unreadTotal } = useTeacherUnreadCounts();

  // Close user menu when route changes
  useEffect(() => {
    setUserMenuOpen(false);
  }, [location.pathname]);

  // Update user data when localStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      const updatedUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
      setUser(updatedUser);
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom events (for same-tab updates)
    window.addEventListener('userDataUpdated', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userDataUpdated', handleStorageChange);
    };
  }, []);

  // Close user menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    };

    if (userMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [userMenuOpen]);

  // Get user data
  const userName = user.name || 'User';
  const userEmail = user.email || 'user@example.com';
  const userInitials = userName.split(' ').map(n => n[0]).join('').toUpperCase() || 'U';

  const handleMouseEnter = (e, text) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltip({
      show: true,
      text,
      top: rect.top + rect.height / 2,
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ show: false, text: "", top: 0 });
  };

  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen);
  };

  const handleLogout = async () => {
    console.log('Sign out button clicked');
    
    try {
      // Выходим из Supabase Auth
      console.log('Calling signOut from Supabase...');
      await signOut();
      console.log('SignOut successful');
    } catch (error) {
      console.error('Error signing out from Supabase:', error);
      // Продолжаем выход даже если была ошибка
    }
    
    // Очищаем localStorage (на всякий случай, даже если signOut уже очистил)
    console.log('Clearing localStorage...');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('isAuthenticated');
    setUserMenuOpen(false);
    
    // Редирект на страницу входа с полной перезагрузкой
    console.log('Redirecting to login...');
    window.location.href = '/login'; // Используем window.location.href для полной перезагрузки
  };

  return (
    <>
      <div className="sidebar" ref={sidebarRef}>
        <nav className="sidebar-nav">
          {links.filter(link => !link.adminOnly || isBlogAdmin()).map(link => (
            <NavLink
              key={link.name}
              to={link.path}
              data-tour={`nav-${link.name.toLowerCase()}`}
              className={({ isActive }) => "sidebar-link" + (isActive ? " active" : "")}
              end
              onClick={(e) => {
                // Unsaved changes guard (set by pages like StudentProfile new)
                try {
                  const guard = window.__novasUnsavedChangesGuard;
                  if (typeof guard === 'function') {
                    const ok = guard(() => navigate(link.path));
                    if (!ok) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                  }
                } catch (_) {}
              }}
              onMouseEnter={e => handleMouseEnter(e, link.name)}
              onMouseLeave={handleMouseLeave}
            >
              <span className="sidebar-svg-icon">
                {link.icon}
                {link.name === 'Students' && unreadTotal > 0 && (
                  <span className="sidebar-unread-badge">{unreadTotal > 99 ? '99+' : unreadTotal}</span>
                )}
              </span>
            </NavLink>
          ))}
          
          {/* User Profile Icon */}
          <div
            className="sidebar-link profile-icon-container"
            data-tour="nav-profile"
            style={{ marginTop: "auto", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px", borderRadius: "50%", width: "48px", height: "48px" }}
            onClick={toggleUserMenu}
            onMouseEnter={e => handleMouseEnter(e, "Profile")}
            onMouseLeave={handleMouseLeave}
          >
            <div style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "radial-gradient(circle at 70% 30%, #ff7b1c 0%, #e6420b 40%, #1a1a1a 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              cursor: "pointer",
              border: "1px solid gray",
              flexShrink: 0
            }}>
              <span style={{
                color: "white",
                fontWeight: 600,
                fontSize: "12px",
                letterSpacing: "0.5px",
                textTransform: "uppercase"
              }}>{userInitials}</span>
            </div>
          </div>
        </nav>
      </div>
      
      {/* User Menu */}
      {userMenuOpen && (
        <div 
          style={{
            position: "fixed",
            left: "100px",
            bottom: "100px",
            background: "white",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            padding: "8px 0",
            zIndex: 9999,
            minWidth: "200px"
          }}
          onClick={(e) => {
            console.log('User menu container clicked');
            e.stopPropagation();
          }}
        >
          <div style={{ padding: "12px 16px", borderBottom: "1px solid #eee" }}>
            <div style={{ fontWeight: "600", fontSize: "14px" }}>{userName}</div>
            <div style={{ fontSize: "12px", color: "#666" }}>{userEmail}</div>
          </div>
          <div style={{ padding: "4px 0" }}>
            <button 
              onMouseDown={(e) => {
                console.log('Profile Settings mousedown');
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => {
                console.log('Profile Settings clicked');
                e.preventDefault();
                e.stopPropagation();
                const performNav = () => {
                  setUserMenuOpen(false);
                  setTimeout(() => navigate('/profile-settings'), 100);
                };
                try {
                  const guard = window.__novasUnsavedChangesGuard;
                  if (typeof guard === 'function' && !guard(performNav)) return;
                } catch (_) {}
                performNav();
              }}
              style={{
                width: "100%",
                background: "none",
                border: "none",
                padding: "8px 16px",
                textAlign: "left",
                cursor: "pointer",
                fontSize: "14px",
                transition: "background-color 0.2s ease"
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#f5f5f5"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
            >
              Profile Settings
            </button>
            <button 
              style={{
                width: "100%",
                background: "none",
                border: "none",
                padding: "8px 16px",
                textAlign: "left",
                cursor: "pointer",
                fontSize: "14px",
                transition: "background-color 0.2s ease"
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#f5f5f5"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
            >
              Subscription
            </button>
            <div style={{ height: "1px", background: "#eee", margin: "4px 0" }}></div>
            <button 
              onMouseDown={(e) => {
                console.log('Sign Out button mousedown');
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => {
                console.log('Sign Out button clicked');
                e.preventDefault();
                e.stopPropagation();
                const performLogout = () => {
                  setUserMenuOpen(false);
                  handleLogout();
                };
                try {
                  const guard = window.__novasUnsavedChangesGuard;
                  if (typeof guard === 'function' && !guard(performLogout)) return;
                } catch (_) {}
                performLogout();
              }}
              style={{
                width: "100%",
                background: "none",
                border: "none",
                padding: "8px 16px",
                textAlign: "left",
                cursor: "pointer",
                fontSize: "14px",
                color: "#dc2626",
                transition: "background-color 0.2s ease"
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#fef2f2"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
            >
              Sign Out
            </button>
          </div>
        </div>
      )}
      
      {tooltip.show && (
        <div
          className="sidebar-tooltip"
          style={{
            position: "fixed",
            left: 100,
            top: tooltip.top,
            transform: "translateY(-50%)",
            background: "rgba(255,255,255,0.7)",
            color: "#222",
            fontWeight: 400,
            fontSize: 12,
            padding: "2.5px 8px",
            borderRadius: 6,
            boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
            zIndex: 9999,
            pointerEvents: "none",
            userSelect: "none",
            whiteSpace: "nowrap",
            opacity: tooltip.show ? 1 : 0,
            transition: "opacity 0.18s cubic-bezier(.4,0,.2,1)"
          }}
        >
          {tooltip.text}
        </div>
      )}
    </>
  );
}
